import React, { Component } from "react";
import { withStyles } from "@mui/styles";
import { Styles } from "../../../../styles/material-styles";
import { Grid, Button, Dialog, TextField } from '@mui/material';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';

import { AbilityContext } from '../../../../config/ability-context';
import { injectIntl } from 'react-intl';
import Api2Talk from "../../../../services/api2talk";
import PropTypes from 'prop-types';
import * as componentActions from '../../../../redux/actions/phoneregistrationrequests';
import { bindActionCreators } from 'redux';
import SyncIcon from '@mui/icons-material/Sync';
import { FormattedMessage } from 'react-intl';
import { FormControl, FormLabel, FormControlLabel, FormGroup, Switch } from '@mui/material'
import { PROVIDER_CONFIG_NAME } from '../../../../utils/enums/provider-config';
import DialogGeneral from '../../../../components/dialog-general';



class ProviderSettings extends Component {

  constructor(props) {
    super(props);

    const { phoneregistrationrequests } = this.props;
    this.state = {
      requestnumber: phoneregistrationrequests.phoneregistrationrequests,
      item: {
        id: phoneregistrationrequests.phoneregistrationrequests.messageproviderconfig.id,
        baseurl: phoneregistrationrequests.phoneregistrationrequests.messageproviderconfig && phoneregistrationrequests.phoneregistrationrequests.messageproviderconfig.baseurl ? phoneregistrationrequests.phoneregistrationrequests.messageproviderconfig.baseurl : null,
        messageprovidername: phoneregistrationrequests.phoneregistrationrequests.messageprovider ? phoneregistrationrequests.phoneregistrationrequests.messageprovider.name : null,
        accountsid: phoneregistrationrequests.phoneregistrationrequests.messageproviderconfig && phoneregistrationrequests.phoneregistrationrequests.messageproviderconfig.accountsid ? phoneregistrationrequests.phoneregistrationrequests.messageproviderconfig.accountsid : null,
        authtoken: phoneregistrationrequests.phoneregistrationrequests.messageproviderconfig && phoneregistrationrequests.phoneregistrationrequests.messageproviderconfig.authtoken ? phoneregistrationrequests.phoneregistrationrequests.messageproviderconfig.authtoken : null,
      },
      forceSynchronizationOfApprovedTemplates: false,
      openInstagramSynchronizationConfirmation: false,
      instagramSynchronizationInProgress: false

    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.syncTemplates = this.syncTemplates.bind(this);
    this.handleChangeSwitch = this.handleChangeSwitch.bind(this)
  }


  handleInputChange(e) {
    const name = e.target.name
    const value = e.target.value

    this.setState((prevState) => ({
      item: {
        ...prevState.item,
        [name]: value
      }
    }))
  }

  handleChangeSwitch = (e) => {
    let { name, checked } = e.target

    this.setState({ forceSynchronizationOfApprovedTemplates: checked })
  }

  openInstagramSynchronizationConfirmation = () => {
    if (!this.state.instagramSynchronizationInProgress) {
      this.setState({ openInstagramSynchronizationConfirmation: true });
    }
  }

  closeInstagramSynchronizationConfirmation = () => {
    this.setState({ openInstagramSynchronizationConfirmation: false });
  }

  confirmInstagramSynchronization = () => {
    this.setState({ openInstagramSynchronizationConfirmation: false }, () => {
      this.synchronizeInstagram();
    });
  }

  cleanupInstagramOAuth = (closePopup = false) => {
    if (this.instagramPopupInterval) {
      clearInterval(this.instagramPopupInterval);
      this.instagramPopupInterval = null;
    }

    if (this.instagramMessageHandler) {
      window.removeEventListener('message', this.instagramMessageHandler);
      this.instagramMessageHandler = null;
    }

    if (closePopup && this.instagramPopup && !this.instagramPopup.closed) {
      this.instagramPopup.close();
    }

    this.instagramPopup = null;
  }

  notifyInstagramSynchronization = (variant, message) => {
    this.setState({ instagramSynchronizationInProgress: false });
    this.props.getNotification(false, true, variant, message);
  }

  synchronizeInstagram = () => {
    const { intl, setLoadingState } = this.props;

    if (this.state.instagramSynchronizationInProgress) {
      return;
    }

    if (Api2Talk == null) {
      this.notifyInstagramSynchronization(
        'error',
        intl.formatMessage({ id: 'instagram.sync.api.error' })
      );
      return;
    }

    const clientId = process.env.REACT_APP_MEXX_INSTAGRAM_CLIENT_ID;
    if (!clientId) {
      this.notifyInstagramSynchronization(
        'error',
        intl.formatMessage({ id: 'instagram.sync.config.error' })
      );
      return;
    }

    this.setState({ instagramSynchronizationInProgress: true });
    setLoadingState(true);

    const redirectUri = `${window.location.origin}/pt/authorize-instagram`;
    const authUrl = new URL('https://www.instagram.com/oauth/authorize');
    authUrl.searchParams.append('force_reauth', 'true');
    authUrl.searchParams.append('client_id', clientId);
    authUrl.searchParams.append('redirect_uri', redirectUri);
    authUrl.searchParams.append('response_type', 'code');
    authUrl.searchParams.append(
      'scope',
      'instagram_business_basic,instagram_business_manage_messages'
    );

    const popupWidth = 500;
    const popupHeight = 700;
    const left = window.screenX + (window.outerWidth - popupWidth) / 2;
    const top = window.screenY + (window.outerHeight - popupHeight) / 2;
    const popupFeatures = `width=${popupWidth},height=${popupHeight},left=${left},top=${top},toolbar=no,menubar=no,scrollbars=yes,resizable=yes,status=no`;

    this.instagramPopup = window.open(
      authUrl.toString(),
      'instagram_oauth_synchronization',
      popupFeatures
    );

    if (!this.instagramPopup) {
      this.notifyInstagramSynchronization(
        'error',
        intl.formatMessage({ id: 'instagram.sync.popup.blocked' })
      );
      return;
    }

    let codeReceived = false;

    this.instagramMessageHandler = async (event) => {
      if (
        event.origin !== window.location.origin ||
        event.source !== this.instagramPopup ||
        event.data?.type !== 'INSTAGRAM_OAUTH_RESPONSE'
      ) {
        return;
      }

      codeReceived = true;
      this.cleanupInstagramOAuth(false);

      if (event.data.error) {
        this.notifyInstagramSynchronization(
          'error',
          event.data.error_description || event.data.error
        );
        return;
      }

      if (!event.data.code) {
        this.notifyInstagramSynchronization(
          'error',
          intl.formatMessage({ id: 'instagram.sync.error' })
        );
        return;
      }

      await this.exchangeInstagramCodeForSynchronization(event.data.code);
    };

    window.addEventListener('message', this.instagramMessageHandler);

    this.instagramPopupInterval = setInterval(() => {
      if (this.instagramPopup && this.instagramPopup.closed) {
        this.cleanupInstagramOAuth(false);

        if (!codeReceived) {
          this.notifyInstagramSynchronization(
            'warning',
            intl.formatMessage({ id: 'instagram.sync.cancelled' })
          );
        }
      }
    }, 500);
  }

  exchangeInstagramCodeForSynchronization = async (code) => {
    const { intl } = this.props;

    try {
      const data = new FormData();
      data.append('code', code);
      data.append('registrationnumberrequestid', this.state.requestnumber.id);

      const result = await Api2Talk.post(
        '/registrationphonenumber/instagram/oauth/synchronize',
        data,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json'
          }
        }
      );

      if (result?.data?.success === true) {
        // Descarta o token exibido antes da sincronização, mesmo se a releitura falhar.
        let messageproviderconfig = { ...this.state.requestnumber.messageproviderconfig, authtoken: null };
        try {
          const configuration = await Api2Talk.get(`/messageproviderconfig/${this.state.item.id}`);
          if (configuration?.data?.success === true && configuration.data.data) {
            messageproviderconfig = { ...messageproviderconfig, ...configuration.data.data };
          }
        } catch {
          // A sincronização já foi persistida. O salvamento comum preserva a credencial no backend.
        }
        // O servidor relê os campos após o commit; não apagar um alerta concorrente mais recente.
        const renewal = result.data.data || {};
        const requestnumber = {
          ...this.state.requestnumber,
          messageproviderconfig,
          tokenrenewalstatus: renewal.tokenrenewalstatus ?? 1,
          tokenrenewalerrorcode: renewal.tokenrenewalerrorcode ?? null,
          tokenrenewalfailedat: renewal.tokenrenewalfailedat ?? null,
        };
        this.setState(prevState => ({
          requestnumber,
          item: {
            ...prevState.item,
            authtoken: messageproviderconfig.authtoken ?? null,
            accountsid: messageproviderconfig.accountsid ?? null,
            baseurl: messageproviderconfig.baseurl ?? null,
          },
        }));
        this.props.addCurrent(requestnumber);
        this.props.onInstagramSynchronized?.(requestnumber);
        this.notifyInstagramSynchronization(
          'success',
          result.data.message || intl.formatMessage({ id: 'instagram.sync.success' })
        );
        return;
      }

      this.notifyInstagramSynchronization(
        'error',
        result?.data?.message || intl.formatMessage({ id: 'instagram.sync.error' })
      );
    } catch (err) {
      this.notifyInstagramSynchronization(
        'error',
        err?.response?.data?.message || intl.formatMessage({ id: 'instagram.sync.error' })
      );
    }
  }


  async syncTemplates(e) {


    const { getNotification, setLoadingState } = this.props;
    setLoadingState(true)
    let data = {
      id: this.state.requestnumber.id,
      forceSynchronizationOfApprovedTemplates: this.state.forceSynchronizationOfApprovedTemplates
    }

    //Api nula
    if (Api2Talk == null) {
      getNotification(false, true, 'error', "Api de mensageria não configurada.")
      return;
    }


    Api2Talk.put('registrationphonenumber/sync/template', data)
      .then((result) => {
        if (result.data.success) {
          getNotification(false, true, 'success', "Sincronização realizada com sucesso")


        } else {
          const intl = this.props.intl;
          getNotification(false, true, 'error', result.data.errors && result.data.errors[0] ? result.data.errors[0] : intl.formatMessage({ id: "process.error" }))

        }
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.errors) {
          const intl = this.props.intl;
          getNotification(false, true, 'error', err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" }))

        } else {
          const intl = this.props.intl;
          getNotification(false, true, 'error', err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" }))

        }
      });

  }



  async handleSubmit(e) {

    e.preventDefault();
    const { getNotification, setLoadingState } = this.props;
    setLoadingState(true)

    let data = new FormData();
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };

    //Api nula
    if (Api2Talk == null) {
      getNotification(false, true, 'error', "Api de mensageria não configurada.")
      return;
    }
    const providerId = this.state.requestnumber?.messageproviderid || this.state.requestnumber?.messageprovider?.id;
    for (let key in this.state.item) {
      // O token do Instagram é controlado pela sincronização e pela renovação automática.
      if (key === 'authtoken' && Number(providerId) === PROVIDER_CONFIG_NAME.INSTAGRAM) continue;
      data.append(key, this.state.item[key])
    }

    Api2Talk.put('messageproviderconfig', data, config)
      .then((result) => {
        if (result.data.success) {
          getNotification(false, true, 'success', "Configurações de provedor atualizadas com sucesso")
          if (result.data && result.data.data) {
            const messageproviderconfig = result.data.data;
            this.setState(prevState => ({
              requestnumber: { ...prevState.requestnumber, messageproviderconfig },
              item: { ...prevState.item, authtoken: messageproviderconfig.authtoken ?? null },
            }));
            this.props.updateMessageProviderConfig(messageproviderconfig)
          }

        } else {
          const intl = this.props.intl;
          getNotification(false, true, 'error', result.data.errors && result.data.errors[0] ? result.data.errors[0] : intl.formatMessage({ id: "process.error" }))

        }
      })
      .catch((err) => {
        if (err.response && err.response.data.errors) {
          const intl = this.props.intl;
          getNotification(false, true, 'error', err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" }))

        } else {
          const intl = this.props.intl;
          getNotification(false, true, 'error', err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" }))

        }
      });

  }



  componentDidMount() {
  }

  componentWillUnmount() {
    this.cleanupInstagramOAuth(true);
  }




  render() {

    const { item } = this.state;
    const { classes } = this.props;
    const intl = this.props.intl;
    const providerId = this.state.requestnumber?.messageproviderid || this.state.requestnumber?.messageprovider?.id;
    const isWhatsAppProvider = Number(providerId) === PROVIDER_CONFIG_NAME.WHATSAPP;
    const isInstagramProvider = Number(providerId) === PROVIDER_CONFIG_NAME.INSTAGRAM;


    return (

      <div>
        <form name='myForm' className={classes.form} encType='multipart/form-data' onSubmit={this.handleSubmit}>
          <Grid container spacing={2} style={{ marginTop: 15 }}>



            {isWhatsAppProvider && (
              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button variant="contained" color="primary" endIcon={<SyncIcon />} onClick={this.syncTemplates} >
                  Sincronizar modelos padrões
                </Button>
              </Grid>
            )}
            {isInstagramProvider && (
              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  endIcon={<SyncIcon />}
                  disabled={this.state.instagramSynchronizationInProgress}
                  onClick={this.openInstagramSynchronizationConfirmation}
                >
                  {intl.formatMessage({ id: 'instagram.sync.button' })}
                </Button>
              </Grid>
            )}
            <Grid item xs={12} sm={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <FormControl component="fieldset" variant="standard">

                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.forceSynchronizationOfApprovedTemplates}
                        onChange={this.handleChangeSwitch}
                        name="forceSynchronizationOfApprovedTemplates" />
                    }
                    label={intl.formatMessage({ id: "Forçar sincronização de templates já aprovados?" })} />
                </FormGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                label="Nome do provedor"
                variant="outlined"
                value={item.messageprovidername}
                disabled
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                label="URL api"
                variant="outlined"
                name="baseurl"
                value={item.baseurl}
                onChange={this.handleInputChange}
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                label="Número do aplicativo meta associado ao numero registrado"
                variant="outlined"
                name="accountsid"
                value={item.accountsid ? item.accountsid : ''}
                onChange={this.handleInputChange}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                label="Número do parceiro"
                variant="outlined"
                value={this.state.requestnumber?.companyaccountid || ''}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                label="Token de acesso ao provedor"
                variant="outlined"
                value={item.authtoken ? item.authtoken : ''}
                name="authtoken"
                onChange={this.handleInputChange}
                disabled
              />
            </Grid>
            <Grid container style={{ marginTop: '25px' }}>

              <Grid item xs={4} />
              <Grid item xs={4} />
              {/* Container para alinhar o botão à direita */}
              <Grid item xs={4} container alignItems="flex-end" justifyContent="flex-end">
                <Button variant="contained" color="primary" type="submit" fullWidth disabled={this.state.instagramSynchronizationInProgress}>
                  Salvar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
        <DialogGeneral
          open={this.state.openInstagramSynchronizationConfirmation}
          openOrCloseModalFunction={this.closeInstagramSynchronizationConfirmation}
          handleConfirmation={this.confirmInstagramSynchronization}
          dialogTitle={intl.formatMessage({ id: 'instagram.sync.confirm.title' })}
          dialogSubTitle={intl.formatMessage({ id: 'instagram.sync.confirm.message' })}
        />
      </div>


    );
  }
}
ProviderSettings.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  userSession: state.userSession,
  phoneregistrationrequests: state.phoneregistrationrequests
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(componentActions, dispatch);


//export default injectIntl(withRouter(connect(mapStateToProps)(withStyles(Styles)(ProviderSettings))));
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(ProviderSettings)));
ProviderSettings.contextType = AbilityContext;
